<script>
  import { vendey, pipe } from '../lib/api.js';
  import { cashRegisterRows } from '../lib/cash-register.js';
  import DataTable from './DataTable.svelte';
  import { exportCsv } from '../lib/export.js';
  export let session;
  let totals = []; let totalsError = ''; let busy = false;
  let totalsLoaded = false; let queriedAt = new Date();
  const dayFormat = new Intl.DateTimeFormat('es-PE', { dateStyle: 'full', timeZone: 'America/Lima' });
  const moneyFormat = new Intl.NumberFormat('es-PE', { style: 'currency', currency: 'PEN' });
  $: totalSales = totals.reduce((sum, row) => sum + (Number(row.total ?? row.TOTAL) || 0), 0);
  function exportClosing() {
    const rows = [...totals, { tipopago: 'TOTAL', total: totalSales }].map(row => ({ Fecha: dayFormat.format(queriedAt), ...row }));
    exportCsv(rows, 'cierre-caja.csv');
  }
  async function load() {
    busy = true; totals = []; totalsError = ''; totalsLoaded = false; queriedAt = new Date();
    try {
      totals = cashRegisterRows(await vendey('sp_sumatoria_tipo_pago', pipe([session.seller, session.store])));
      totalsLoaded = true;
    } catch (reason) { totalsError = `No se pudieron consultar los pagos: ${reason.message}`; }
    finally { busy = false; }
  }
</script>
<section class="page-panel"><span class="eyebrow">{session.boxName}</span><h2>Cierre de caja</h2><p>{session.seller} · {session.store}</p>
  <p class="closing-date">Día del cierre: <time datetime={queriedAt.toISOString()}>{dayFormat.format(queriedAt)}</time></p>
  <button class="primary-action" on:click={load} disabled={busy}>{busy ? 'Consultando…' : 'Consultar cierre de turno'}</button>
  <h3>Totales por tipo de pago</h3>
  {#if totalsError}<p class="notice error" role="alert">{totalsError}</p>{/if}
  {#if totalsLoaded}
    <div class="closing-total" role="status"><span>Total de ventas del día</span><strong>{moneyFormat.format(totalSales)}</strong></div>
  {/if}
  <DataTable rows={totals} caption="Pagos de la caja" />
  <button class="secondary-action" disabled={!totalsLoaded || busy} on:click={exportClosing}>Exportar cierre CSV</button>
</section>

<style>
  .closing-date { color: var(--muted); }
  .closing-total { display: flex; flex-wrap: wrap; align-items: center; justify-content: space-between; gap: 12px; margin-top: 16px; padding: 18px; border: 1px solid var(--line); border-radius: 12px; background: #eef6ed; color: var(--green-800); }
  .closing-total span { font-weight: 700; }
  .closing-total strong { font-size: 1.7rem; }
</style>
